import {
  Backdrop,
  Box,
  Button,
  Modal,
  Typography,
  useTheme,
} from '@mui/material';
import { colors } from '../../theme/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  onClose: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ onClose }) => {
  const { t } = useTranslation('loadingModal');
  const theme = useTheme();
  const onGetStarted = () => {
    localStorage.removeItem('userDataLoadProgress');
    onClose();
  };
  return (
    <Modal
      open
      onClose={(event, reason) => {
        // Prevent closing by backdrop click or escape key
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onGetStarted();
        }
      }}
      disableEscapeKeyDown
      data-testid="confirm-modal"
    >
      <Backdrop open sx={{ zIndex: theme.zIndex.modal + 1 }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            borderRadius: 3,
            boxShadow: 24,
            p: { xs: 3, sm: 4 },
            width: { xs: '90%', sm: 400 },
            textAlign: 'center',
          }}
          data-testid="confirm-modal-content"
        >
          <CheckCircleIcon
            sx={{ fontSize: 48, color: 'success.main' }}
            data-testid="confirm-modal-icon"
          />
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ color: colors.primary }}
            gutterBottom
            data-testid="confirm-modal-title"
          >
            {t('readyTitle')}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: colors.primary, mb: 3 }}
            data-testid="confirm-modal-description"
          >
            {t('readyDescription')}
          </Typography>
          <Button
            onClick={onGetStarted}
            variant="contained"
            fullWidth
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              borderRadius: '10px',
              color: colors.white,
              backgroundColor: '#19469D',
              '&:hover': {
                backgroundColor: '#032363',
              },
            }}
            data-testid="confirm-modal-button"
          >
            {t('getStartedButton')}
          </Button>
        </Box>
      </Backdrop>
    </Modal>
  );
};

export default ConfirmModal;
